import React, { Fragment } from 'react';
import { Route, withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Accordion } from 'core/controls';
import { TranslateContext } from 'core/translate';
import ScrollTop from '../../common/ScrollTop';
import SimpleOptionGroup from '../../common/options/SimpleOptionGroup';
import DriveTypeOptionGroup from '../../common/options/DriveTypeOptionGroup';
import TrimOptionGroup from '../../common/options/TrimOptionGroup';
import TrimFeaturesModal from '../features/TrimFeaturesModal';

const TrimWithoutFiltering = props => {
  const {
    engines,
    driveTypes,
    styles,
    styleId,
    disableCompare,
    disclaimer,
    appResources,
    breakpoint,
    selections,
    onChange,
    onDetails
  } = props;

  return (
    <ScrollTop>
      <Accordion>
        <TranslateContext.Consumer>
          {translate => (
            <Fragment>
              <TrimOptionGroup
                options={styles}
                styleId={styleId}
                disclaimer={disclaimer}
                disableCompare={disableCompare}
                onChange={option => onChange('styleId', option)}
              />
              <DriveTypeOptionGroup
                options={driveTypes}
                disclaimer={disclaimer}
                onChange={option => onChange('driveType', option)}
              />
              <SimpleOptionGroup
                header={translate('component.common.select.engine')}
                options={_.sortBy(engines, ['invoice'])}
                disableSingleOption={true}
                hidePrice={true}
                hideSingleCount={true}
                analyticsKey={translate('component.common.select.engine')}
                id="configuration-engines"
                onChange={option => onChange('engine', option)}
                onDetails={onDetails}
              />
            </Fragment>
          )}
        </TranslateContext.Consumer>
      </Accordion>
      <Route
        path="/trim/features/:styleId"
        render={({ match, history }) => {
          const styleId = match.params.styleId;
          const style = _.find(styles, { id: styleId });
          return (
            <TrimFeaturesModal
              style={style}
              appResources={appResources}
              breakpoint={breakpoint}
              disclaimer={disclaimer}
              selections={selections}
              disableCompare={true}
              onClose={() => {
                history.push('/trim');
              }}
              onSelect={() => {
                history.push('/trim');
                onChange('styleId', style);
              }}
            />
          );
        }}
      />
    </ScrollTop>
  );
};

export default withRouter(TrimWithoutFiltering);
